import { render } from "./AnnotationEditorGalleryGridItem.vue?vue&type=template&id=306257a6&scoped=true"
import script from "./AnnotationEditorGalleryGridItem.vue?vue&type=script&lang=js"
export * from "./AnnotationEditorGalleryGridItem.vue?vue&type=script&lang=js"

import "./AnnotationEditorGalleryGridItem.vue?vue&type=style&index=0&id=306257a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306257a6"]])

export default __exports__